export default "__VITE_ASSET__ChrQlfVw__";